<template>

  <div class="form-row">
    <div class="col">
        <color-picker v-model="color" @change="inputColor" />
    </div>
    <div class="col">
      <input type="number" class="form-control" v-model="width" @input="input">
    </div>
</div>
</template>
<style scoped>

</style>
<script>

import ColorPicker from './ColorPicker';

export default {
  props: ['config', 'name', 'value'],
  components:{
      'color-picker':ColorPicker,
  },
  data(){
      return {
          color:'#cccccc',
          width:'1',
      }
  },
  created(){
    if(!this.value) return;
    var match = this.value.match(/(\d+)px(?: solid)? (#.*|rgba.*)/);
    if(!match) return;
    this.width = parseInt(match[1]);
    this.color = match[2];
  },
  methods:{
    inputColor(newcolor){
      this.color = newcolor;
      this.input();
    },
    input(){
      this.$emit('change',this.width+'px '+this.color);
    },
  }

}
</script>
